export const FormStatus = {
    none: 'none',
    processing: 'processing',
    successful: 'successful',
};
